import React from 'react';
import { FAQ } from '../components/FAQ';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useLanguage, Language } from '../contexts/LanguageContext';
type S = {
  stillHeading: string;
  stillBody: string;
  stillBtn: string;
};
// EN/ES finalized. HT/VI = best effort, pending native review.
const T: Record<Language, S> = {
  en: {
    stillHeading: 'Still have questions?',
    stillBody: 'Our support team is happy to help — in your language.',
    stillBtn: 'Contact us'
  },
  es: {
    stillHeading: '¿Todavía tiene preguntas?',
    stillBody: 'Nuestro equipo de soporte con gusto le ayuda — en su idioma.',
    stillBtn: 'Contáctenos'
  },
  ht: {
    stillHeading: 'Ou toujou gen kesyon?',
    stillBody: 'Ékip sipò nou an kontan ede ou — nan lang ou.',
    stillBtn: 'Kontakte nou'
  },
  vi: {
    stillHeading: 'Vẫn còn thắc mắc?',
    stillBody: 'Đội ngũ hỗ trợ của chúng tôi rất sẵn lòng giúp đỡ — bằng ngôn ngữ của quý vị.',
    stillBtn: 'Liên hệ với chúng tôi'
  }
};

// Lands directly on the FAQ content. The FAQ already carries its own heading,
// so there is no separate (repeated) page title.
export function FAQPage() {
  const {
    language
  } = useLanguage();
  const t = T[language];
  return <div data-id="element-397" data-mp="3t7ly2of7kfz0">
      <FAQ data-id="element-398" data-mp="3oavlib2m42ic" />

      {/* Still have questions */}
      <section className="py-20 bg-white border-t border-brand-border" data-id="element-399" data-mp="3oc6ls0wums4p">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-400" data-mp="ptrjrg4vrvdb">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-textPrimary mb-4" data-id="element-401" data-mp="ku57pa0sgl63">
            {t.stillHeading}
          </h2>
          <p className="text-lg text-brand-textSecondary mb-8" data-id="element-402" data-mp="fu91r58j6jnw">{t.stillBody}</p>
          <Link to="/contact" className="inline-flex items-center gap-2 bg-brand-accent hover:bg-brand-accentHover text-brand-textPrimary px-8 py-4 rounded-full font-semibold text-lg transition-all shadow-sm hover:shadow-md focus:outline-none focus:ring-2 focus:ring-brand-accent focus:ring-offset-2 focus:ring-offset-brand-bg group" data-id="element-403" data-mp="aw7j2lf0omcy">
            {t.stillBtn}
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-404" data-mp="1ro2pq8e1l66u" />
          </Link>
        </div>
      </section>
    </div>;
}